import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FormState, InteractionSumbissionState } from 'types/interaction.type';

export const initialState: InteractionSumbissionState = {
  forms: {},
};

export const interactionSlice = createSlice({
  name: 'interaction',
  initialState,
  reducers: {
    updateForm: (state, action: PayloadAction<FormState>) => {
      state.forms[action.payload.id] = action.payload;
    },
  },
});

export const { updateForm } = interactionSlice.actions;

export default interactionSlice.reducer;
